<template>
  <div class="page-header d-flex flex-row justify-content-between align-items-center page-content"
       :class="{
          'padleft': !leftDrawerOpen, 'padright': !rightDrawerOpen, [headerClasses]: true,
          'sticky':stickyHeader,
          'sticky-left': stickyHeader && screenSizeId >= 3 ? leftDrawerOpen : false,
          'sticky-right': stickyHeader &&  screenSizeId >= 3 ? rightDrawerOpen : false
        }"
       style="height: 70px; min-height: 70px; max-height: 70px; z-index: 2;">
    <h5 class="mb-0 m-2" v-if="title" :style="'min-width: ' + minTitleWidth">{{ title }}</h5>
    <ks-text v-if="qaAble" :text="pageRequiredPermissions"/>
    <slot/>
    <ks-button
        style="margin-left: auto;" v-if="showNewButton"
        :size="screenSizeId >= 3 ? 'md' : 'sm'"
        :color="screenSizeId >= 3 ? '' : 'link'"
        :label="newButtonLabel"
        :showFloatingInMobile="true"
        :classIcon="newButtonIcon"
        @onClick="$emit('newButtonClicked')"
        :style="'min-width: ' + minNewButtonWidth"
    />
    <slot name='end'/>
  </div>
</template>

<script>
export default {
  name: 'ks-list-header',
  props: {
    stickyHeader: {type: Boolean, default: false},
    headerClasses: {type: String, default: ''},
    showNewButton: {type: Boolean, default: false},
    newButtonLabel: {type: String, default: null},
    newButtonIcon: {type: String, default: 'fas fa-plus'},
    title: {type: String, default: null},
    minNewButtonWidth: {type: String, default: '150px'},
    minTitleWidth: {type: String, default: null},
  },
  watch: {
  },
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    },
    pageRequiredPermissions(){
      return this.$route.meta.middlewares && this.$route.meta.middlewares.length >0?this.$route.meta.middlewares[0]["rms_ui/validatePermissionsMiddleware"][0]:null;
    },
    activeViewType() {
      return this.$parent.activeViewType;
    },
    columns() {
      return this.$parent.columns;
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    leftDrawerOpen() {
      return app.leftDrawerStatus.isOpen
    },
    rightDrawerOpen() {
      return app.rightDrawerStatus.isOpen
    },
    hasSlotHeader() {
      return !!this.$slots.header;
    },
  },
  methods: {
    setActiveViewType(type, beforeViewTypeChange) {
      this.$parent.setActiveViewType(type, beforeViewTypeChange);
    }
  },
  data() {
    return {

    }
  }
}
</script>
